import LoadInitialFieldsCustomizationData from './LoadInitialFieldsCustomizationData'
import SaveFieldsCustomizationData from './SaveFieldsCustomizationData'

export default [LoadInitialFieldsCustomizationData, SaveFieldsCustomizationData]
